import { ReactNode } from 'react';

import { Content, Wrapper } from './PageWrapper.styles';

interface PageWrapperProps {
  children: ReactNode;
  className?: string;
}

const PageWrapper = ({
  children,
  className,
}: PageWrapperProps): JSX.Element => (
  <Wrapper>
    <Content className={className}>{children}</Content>
  </Wrapper>
);

export default PageWrapper;
